import { type ReactNode } from 'react';

import styles from '@admin/molecules/Modal/Modal.module.scss';
import { type BaseModalType, useModalContext } from '@admin/organisms/BaseModal';
import { type ArticleBlockType } from '@common/clients/api';
import { CrossIcon } from '@common/svg/icons/components/CrossIcon';

interface Props {
    icon?: ReactNode;
    title: ReactNode;
    contextKey: BaseModalType | ArticleBlockType | string;
}

export const Header = ({ icon, title, contextKey }: Props) => {
    const { closeModal } = useModalContext(contextKey);
    return (
        <header className={'flex justify-between'}>
            <div className={styles['header-title']}>
                {icon ? <span className={styles['header-title-icon']}>{icon}</span> : null}
                <span className={styles['header-title-text']}>{title}</span>
            </div>
            <CrossIcon className={styles['header-close-button']} onClick={closeModal} />
        </header>
    );
};
